/*!
 * Copyright (c) 2017-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */


<script>
import Vue from 'vue'

export default Vue.extend({
  name: 'LoginCallback',
  async beforeMount () {
    try {
      await this.$auth.handleLoginRedirect()
    }
    catch(e) {
      // handle case where we say prompt=none and we want to provide the app a callback. 
      const isInteractionRequiredError = this.$auth.isInteractionRequiredError || this.$auth.idx.isInteractionRequiredError;
      if (isInteractionRequiredError(e)) {
        const { onAuthResume, onAuthRequired } = this.$auth.options;
        const callbackFn = onAuthResume || onAuthRequired;
        if (callbackFn) {
          callbackFn(this.$auth);
          return;
        }
      }
      const { onAuthError } = this.$auth.options;
      if(onAuthError) {
        onAuthError(e); 
        return;
      }
    }
  },
  render() { 
    return this.$scopedSlots.default && this.$scopedSlots.default({})
  }
})
</script>
